import { ref } from 'vue'

// Global state for login dialogs
const showLoginDialog = ref(false)
const showForgetPasswordDialog = ref(false)
const showRegisterDialog = ref(false)

export function useLoginDialog() {
  const openLoginDialog = () => {
    showLoginDialog.value = true
    showForgetPasswordDialog.value = false
    showRegisterDialog.value = false
  }

  const openRegisterDialog = () => {
    showLoginDialog.value = false
    showRegisterDialog.value = true
    showForgetPasswordDialog.value = false
  }

  const openForgetPasswordDialog = () => {
    showLoginDialog.value = false
    showForgetPasswordDialog.value = true
    showRegisterDialog.value = false
  }

  const closeAllDialogs = () => {
    showLoginDialog.value = false
    showForgetPasswordDialog.value = false
    showRegisterDialog.value = false
  }

  const handleShowRegisterDialog = () => {
    showLoginDialog.value = false
    showRegisterDialog.value = true
  }

  const handleShowLoginDialog = () => {
    showRegisterDialog.value = false
    showLoginDialog.value = true
  }

  const onBackToLogin = () => {
    showLoginDialog.value = true
    showForgetPasswordDialog.value = false
  }

  const onShowForgetPasswordDialog = () => {
    showLoginDialog.value = false
    showForgetPasswordDialog.value = true
  }

  return {
    // State
    showLoginDialog,
    showForgetPasswordDialog,
    showRegisterDialog,

    // Actions
    openLoginDialog,
    openRegisterDialog,
    openForgetPasswordDialog,
    closeAllDialogs,
    handleShowRegisterDialog,
    handleShowLoginDialog,
    onBackToLogin,
    onShowForgetPasswordDialog,
  }
}
